import { render, staticRenderFns } from "./CollaboardModalWrapper.vue?vue&type=template&id=b2aa3718&scoped=true"
import script from "./CollaboardModalWrapper.vue?vue&type=script&lang=js"
export * from "./CollaboardModalWrapper.vue?vue&type=script&lang=js"
import style0 from "./CollaboardModalWrapper.vue?vue&type=style&index=0&id=b2aa3718&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2aa3718",
  null
  
)

export default component.exports